var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"catalog-header",class:{ small: _vm.small, large: _vm.large, xLarge: _vm.xLarge, dark: _vm.dark, bold: _vm.bold },attrs:{"cols":"12"},domProps:{"textContent":_vm._s(_vm.header)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }